<div class="rating-container">
  <img *ngFor="let star of stars; index as i" src="{{star}}" alt="" />
</div>
